import { escapeSingleQuotes, isEdmDateOnly, isEdmDateTimeOffset, isEdmGuid } from "../odata-string-utils.ts";
import type { EdmDateTimeOffset, EdmGuid } from "../odata-types.ts";
import { Expression } from "./base/Expression.ts";

export type ValueType = string | number | boolean | null | EdmGuid | EdmDateTimeOffset;

export class LiteralExpression extends Expression {
    readonly type = "literal";
    public value: ValueType;

    constructor(value: ValueType) {
        super();
        this.value = value;
    }

    stringify(): string {
        return stringifyLiteralValue(this.value);
    }

    getKey(): string {
        return String(this.value);
    }
}

export function stringifyLiteralValue(value: ValueType): string {
    if (value === null) {
        return "null";
    }

    switch (typeof value) {
        case "string":
            if (isEdmGuid(value) || isEdmDateTimeOffset(value) || isEdmDateOnly(value)) {
                return value;
            }

            return `'${escapeSingleQuotes(value)}'`;
        case "number":
            return value.toString();
        case "boolean":
            return value ? "true" : "false";
        default:
            return String(value);
    }
}
